import {
  OAUTH_EDIT_REQUEST,
  OAUTH_EDIT_SUCCESS,
  OAUTH_EDIT_FAIL,
  OAUTH_EDIT_RESET,
  OAUTH_UPDATE_REQUEST,
  OAUTH_UPDATE_SUCCESS,
  OAUTH_UPDATE_FAIL,
  OAUTH_UPDATE_RESET,
  OAUTH_DELETE_REQUEST,
  OAUTH_DELETE_SUCCESS,
  OAUTH_DELETE_FAIL,
  OAUTH_DELETE_RESET,
  OAUTH_FACEBOOK_PAGES_REQUEST,
  OAUTH_FACEBOOK_PAGES_SUCCESS,
  OAUTH_FACEBOOK_PAGES_FAIL,
  OAUTH_FACEBOOK_PAGES_RESET,
  OAUTH_FACEBOOK_PAGE_SELECT_REQUEST,
  OAUTH_FACEBOOK_PAGE_SELECT_SUCCESS,
  OAUTH_FACEBOOK_PAGE_SELECT_FAIL,
  OAUTH_FACEBOOK_PAGE_SELECT_RESET,
  OAUTH_INSTAGRAM_ACCOUNTS_REQUEST,
  OAUTH_INSTAGRAM_ACCOUNTS_SUCCESS,
  OAUTH_INSTAGRAM_ACCOUNTS_FAIL,
  OAUTH_INSTAGRAM_ACCOUNTS_RESET,
  OAUTH_INSTAGRAM_ACCOUNT_SELECT_REQUEST,
  OAUTH_INSTAGRAM_ACCOUNT_SELECT_SUCCESS,
  OAUTH_INSTAGRAM_ACCOUNT_SELECT_FAIL,
  OAUTH_INSTAGRAM_ACCOUNT_SELECT_RESET,
} from "../Constants/OAuthConstants";

export const oauthDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case OAUTH_DELETE_REQUEST:
      return {
        loading: true,
      };

    case OAUTH_DELETE_SUCCESS:
      return {
        loading: false,
        success: true,
      };

    case OAUTH_DELETE_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    case OAUTH_DELETE_RESET:
      return {};

    default:
      return state;
  }
};

export const oauthEditReducer = (
  state = {
    recordItem: undefined,
  },
  action,
) => {
  switch (action.type) {
    case OAUTH_EDIT_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case OAUTH_EDIT_SUCCESS:
      return {
        loading: false,
        recordItem: action.payload.item,
      };

    case OAUTH_EDIT_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    case OAUTH_EDIT_RESET:
      return {};

    default:
      return state;
  }
};

export const oauthUpdateReducer = (
  state = {
    data: {},
  },
  action,
) => {
  switch (action.type) {
    case OAUTH_UPDATE_REQUEST:
      return {
        loading: true,
      };

    case OAUTH_UPDATE_SUCCESS:
      return {
        loading: false,
        success: true,
        recordItem: action.payload.item,
      };

    case OAUTH_UPDATE_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    case OAUTH_UPDATE_RESET:
      return {
        data: {},
      };

    default:
      return state;
  }
};

/* Facebook Pages */

export const oauthFacebookPagesGetReducer = (
  state = {
    loadingPages: false,
    pages: [],
    errorPages: null,
  },
  action,
) => {
  switch (action.type) {
    case OAUTH_FACEBOOK_PAGES_REQUEST:
      return {
        loadingPages: true,
        pages: [],
        errorPages: null,
      };

    case OAUTH_FACEBOOK_PAGES_SUCCESS:
      return {
        loadingPages: false,
        pages: action.payload || [],
        errorPages: null,
      };

    case OAUTH_FACEBOOK_PAGES_FAIL:
      return {
        loadingPages: false,
        pages: [],
        errorPages: action.payload,
      };

    case OAUTH_FACEBOOK_PAGES_RESET:
      return {
        loadingPages: false,
        pages: [],
        errorPages: null,
      };

    default:
      return state;
  }
};

/* Facebook Page selection */

export const oauthFacebookPageSelectReducer = (
  state = {
    loading: false,
    success: false,
    data: null,
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case OAUTH_FACEBOOK_PAGE_SELECT_REQUEST:
      return {
        loading: true,
        success: false,
        data: null,
        error: null,
      };

    case OAUTH_FACEBOOK_PAGE_SELECT_SUCCESS:
      return {
        loading: false,
        success: true,
        data: action.payload,
        error: null,
      };

    case OAUTH_FACEBOOK_PAGE_SELECT_FAIL:
      return {
        loading: false,
        success: false,
        data: null,
        error: action.payload,
      };

    case OAUTH_FACEBOOK_PAGE_SELECT_RESET:
      return {
        loading: false,
        success: false,
        data: null,
        error: null,
      };

    default:
      return state;
  }
};

/* Instagram Accounts */

export const oauthInstagramAccountsGetReducer = (
  state = {
    loadingAccounts: false,
    accounts: [],
    errorAccounts: null,
  },
  action,
) => {
  switch (action.type) {
    case OAUTH_INSTAGRAM_ACCOUNTS_REQUEST:
      return {
        loadingAccounts: true,
        accounts: [],
        errorAccounts: null,
      };

    case OAUTH_INSTAGRAM_ACCOUNTS_SUCCESS:
      return {
        loadingAccounts: false,
        accounts: action.payload || [],
        errorAccounts: null,
      };

    case OAUTH_INSTAGRAM_ACCOUNTS_FAIL:
      return {
        loadingAccounts: false,
        accounts: [],
        errorAccounts: action.payload,
      };

    case OAUTH_INSTAGRAM_ACCOUNTS_RESET:
      return {
        loadingAccounts: false,
        accounts: [],
        errorAccounts: null,
      };

    default:
      return state;
  }
};

/* Instagram account selection */

export const oauthInstagramAccountSelectReducer = (
  state = {
    loading: false,
    success: false,
    data: null,
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case OAUTH_INSTAGRAM_ACCOUNT_SELECT_REQUEST:
      return {
        loading: true,
        success: false,
        data: null,
        error: null,
      };

    case OAUTH_INSTAGRAM_ACCOUNT_SELECT_SUCCESS:
      return {
        loading: false,
        success: true,
        data: action.payload,
        error: null,
      };

    case OAUTH_INSTAGRAM_ACCOUNT_SELECT_FAIL:
      return {
        loading: false,
        success: false,
        data: null,
        error: action.payload,
      };

    case OAUTH_INSTAGRAM_ACCOUNT_SELECT_RESET:
      return {
        loading: false,
        success: false,
        data: null,
        error: null,
      };

    default:
      return state;
  }
};
